import { AxiosError } from 'axios';
import { errorNotificationActions } from 'components/common/ErrorNotification/errorNotificationSlice';
import authSaga from 'features/Auth/authSaga';
import barInfoListSaga from 'features/BarGuideInfo/barInfoSaga';
import barMenuListSaga from 'features/BarGuideInfoMenu/barMenuSaga';
import deliverySaga from 'features/Delivery/deliverySaga';
import eatingWaySettingSaga from 'features/EatingWay/eatingWaySettingSaga';
import menuBookEditorSaga from 'features/MenuBook/menuBookEditorSaga';
import menuDetailSaga from 'features/MenuDetail/menuDetailSaga';
import menuListSaga from 'features/MenuList/menuSaga';
import overlaySaga from 'features/OverlayFunction/overlaySaga';
import timeFrameMenuBookSaga from 'features/SaleType/timeFrameMenuBookSaga';
import storeSettingDetailSaga from 'features/Store/storeSettingDetailSaga';
import subMenuGroupSaga from 'features/SubMenuList/subMenuSaga';
import companySaga from 'features/common/companySaga';
import { StatusCodes } from 'http-status-codes';
import { CommonResponse } from 'models';
import { all, put } from 'redux-saga/effects';

export function* handleResponseError(e: AxiosError) {
  if (e.response && e.response.status !== StatusCodes.UNAUTHORIZED) {
    yield put(errorNotificationActions.setError(e));
  }
}

export function* handleResponseMessage(res: CommonResponse<null>) {
  yield put(errorNotificationActions.setMessage(res));
}

export default function* rootSaga() {
  yield all([
    companySaga(),
    authSaga(),
    subMenuGroupSaga(),
    deliverySaga(),
    timeFrameMenuBookSaga(),
    menuDetailSaga(),
    menuListSaga(),
    menuBookEditorSaga(),
    storeSettingDetailSaga(),
    barInfoListSaga(),
    barMenuListSaga(),
    eatingWaySettingSaga(),
    overlaySaga(),
  ]);
}
